import { Box, Divider, Stack } from '@mantine/core';

import { CenterReportCriteriaFree } from '@/module/Laboratory/CenterReportCriteriaFree';
import { CenterReportCriteriaSelect } from '@/module/Laboratory/CenterReportCriteriaSelect';
import { CenterReportCriteriaTemplate } from '@/module/ResearchCenter';

import { Id } from '@/feature/utils';

interface CenterReportCriteriaGatheringProps {
  criteria: CenterReportCriteriaTemplate;
  labId: Id;
}

export function CenterReportCriteriaGathering({ labId, criteria }: CenterReportCriteriaGatheringProps) {
  return (
    <Box
      p="sm"
      component={Stack}
    >
      <Divider />
      {criteria.criteriaType === 'SELECT' && (
        <CenterReportCriteriaSelect
          criteriaCode={criteria.criteriaCode}
          selectType={criteria.selectType}
          labId={labId}
        />
      )}
      {criteria.criteriaType === 'FREE' && (
        <CenterReportCriteriaFree
          criteriaCode={criteria.criteriaCode}
          freeType={criteria.freeType}
          labId={labId}
        />
      )}
    </Box>
  );
}
